module.exports = __webpack_public_path__ + "img/chrome-cast.3f0557f9.svg";